import { IGovernamentalStructureReponse } from "models/response/governamental-strutucture-response";

export interface OrganizationalStructureState {
  governamentalStructures: IGovernamentalStructureReponse[];
  loading: boolean;
}

export const ACTION_TYPES = {
  setGovernamentalStructures: 'setGovernamentalStructures',
  setLoading: 'setLoading',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface OrganizationalStructureAction {
  type: ActionType;
  payload: any;
}

export const OrganizationalStructureReducer = (
  state: OrganizationalStructureState,
  action: OrganizationalStructureAction
): OrganizationalStructureState => {
  switch (action.type) {
    case ACTION_TYPES.setGovernamentalStructures:
      return {
        ...state,
        governamentalStructures: action.payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};